<template>
  <div style="background-color: #f5f6f8; padding: 20px; min-height: 100vh; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
    <div style="background-color: #ffffff; border-radius: 4px; padding: 12px 20px; margin-bottom: 20px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); border: 1px solid #e5e7eb; display: flex; justify-content: space-between; align-items: center;">
      <div style="display: flex; align-items: center; gap: 10px;">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="#555">
          <path d="M4 4h5v5H4V4zm7 0h5v5h-5V4zm7 0h5v5h-5V4zM4 11h5v5H4v-5zm7 0h5v5h-5v-5zm7 0h5v5h-5v-5zM4 18h5v5H4v-5zm7 0h5v5h-5v-5zm7 0h5v5h-5v-5z"/>
        </svg>
        <span style="font-weight: 700; font-size: 15px; color: #444; letter-spacing: 0.5px; text-transform: uppercase;">DAILY COLLECTION RECORD</span>
      </div>
      <button @click="goBack" style="background: #800080; border: 1px solid #d1d5db; border-radius: 4px; padding: 6px 14px; color: #ffffff; font-weight: 600; font-size: 12px; cursor: pointer; display: flex; align-items: center; gap: 6px; box-shadow: 0 1px 2px rgba(0,0,0,0.02);">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
        </svg>
        Close
      </button>
    </div>

    <div style="background-color: #ffffff; border-radius: 4px; padding: 24px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); border: 1px solid #e5e7eb;">
      <div style="display: flex; justify-content: space-between; align-items: flex-start; flex-wrap: wrap;">
        <div style="display: flex; gap: 24px; flex-wrap: wrap; align-items: flex-start;">
          <div v-if="!userImage" style="width: 72px; height: 72px; border-radius: 50%; background-color: #ffffff; border: 1px solid #d1d5db; display: flex; align-items: center; justify-content: center;">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="#9ca3af">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
          </div>
          <div v-else style="width: 72px; height: 72px; border-radius: 50%; overflow: hidden; border: 1px solid #d1d5db;">
            <img :src="imageSrc" style="width: 100%; height: 100%; object-fit: cover;" alt="User avatar">
          </div>

          <div style="display: flex; flex-direction: column; gap: 8px; padding-top: 4px;">
            <div style="font-size: 14px; color: #6b7280; font-weight: 600;">
              Sales Rep Name: <span style="font-weight: 400; color: #111827; margin-left: 4px;">{{ agentName }}</span>
            </div>
            <div style="font-size: 14px; color: #6b7280; font-weight: 600;">
              Mobile: <span style="font-weight: 400; color: #111827; margin-left: 4px;">{{ mobileNumber }}</span>
            </div>
            <div style="display: flex; gap: 10px; flex-wrap: wrap; margin-top: 4px;">
              <span style="background-color: #f0fdf4; color: #166534; padding: 4px 12px; border-radius: 9999px; font-size: 11px; font-weight: 600; display: inline-flex; align-items: center; gap: 6px; border: 1px solid #86efac;">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                </svg>
                USER TYPE - {{ userType }}
              </span>
              <span style="background-color: #f0fdf4; color: #166534; padding: 4px 12px; border-radius: 9999px; font-size: 11px; font-weight: 600; display: inline-flex; align-items: center; gap: 6px; border: 1px solid #86efac;">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                </svg>
                DAILY COLLECTION
              </span>
            </div>
          </div>
        </div>

        <button v-if="permissions.delete" @click="confirmDelete" style="background: #ffffff; border: 1px solid #fca5a5; border-radius: 4px; padding: 8px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #dc2626; transition: all 0.2s;">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
          </svg>
        </button>
      </div>

      <hr style="margin: 24px 0; border: none; border-top: 1px solid #f3f4f6;">

      <div style="display: flex; gap: 32px; flex-wrap: wrap;">
        <div style="flex: 1; min-width: 300px;">
          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Invoice Number</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">INV-2024-001</div>
          </div>

          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Route Name</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">Route - 001</div>
          </div>

          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Dealer Name</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">Laksiri Homes</div>
          </div>

          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Area</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">Colombo | C117-COIN</div>
          </div>

          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Total (LKR)</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">125,000.00</div>
          </div>

          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Receipt Type</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">Cash</div>
          </div>
        </div>

        <div style="flex: 1; min-width: 300px;">
          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Date</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">2024-01-22</div>
          </div>

          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Piyestra Company</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">Piyestra Furniture Pvt. Ltd</div>
          </div>

          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Cash Amount (LKR)</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">75,000.00</div>
          </div>

          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Cheque Amount (LKR)</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">25,000.00</div>
          </div>

          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Advance Amount (LKR)</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">15,000.00</div>
          </div>

          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Cash Limit (LKR)</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">250,000.00</div>
          </div>

          <div style="margin-bottom: 20px;">
            <label style="display: block; font-size: 13px; color: #6b7280; margin-bottom: 6px; font-weight: 500;">Credit Limit (LKR)</label>
            <div style="background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #374151; min-height: 20px; display: flex; align-items: center;">500,000.00</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="deleteDialog" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000;">
      <div style="background-color: white; border-radius: 4px; width: 400px; max-width: 90%; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
        <div style="padding: 16px; background-color: #f9fafb; border-top-left-radius: 4px; border-top-right-radius: 4px; border-bottom: 1px solid #e5e7eb; display: flex; align-items: center; justify-content: space-between;">
          <span style="font-weight: 700; font-size: 14px; color: #374151;">DELETE DAILY COLLECTION DATA</span>
          <button @click="deleteDialog = false" style="background: none; border: none; cursor: pointer; font-size: 20px; color: #6b7280;">&times;</button>
        </div>
        <div style="padding: 24px;">
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 15px;">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#f59e0b">
              <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
            </svg>
            <span style="font-weight: 600; color: #dc2626; font-size: 15px;">Do you want to delete this daily collection record?</span>
          </div>
          <p style="font-size: 13px; color: #4b5563; margin-bottom: 24px; line-height: 1.5;">This daily collection record will be deleted immediately. Once deleted, it can no longer be used for any purpose.</p>
          <hr style="margin: 16px 0; border: none; border-top: 1px solid #e5e7eb;">
          <div style="display: flex; justify-content: flex-end; gap: 12px; margin-top: 20px;">
            <button @click="deleteDialog = false" style="padding: 8px 16px; background: #ffffff; border: 1px solid #d1d5db; border-radius: 4px; font-size: 13px; font-weight: 600; color: #4b5563; cursor: pointer;">CANCEL</button>
            <button @click="deleteItem" style="padding: 8px 16px; background-color: #dc2626; color: white; border: none; border-radius: 4px; font-size: 13px; font-weight: 600; cursor: pointer;">DELETE</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { EventBus } from "@/plugins/event-bus";
import { getPermissions } from "@/plugins/permissions";

export default {
  name: "Daily_Collections_View",
  data() {
    return {
      deleteDialog: false,
      
      collectionId: null,
      
      agentName: 'Loading...',
      mobileNumber: 'Loading...',
      userType: 'SALES REP',
      userImage: null,
      
      permissions: {},
    };
  },

  computed: {
    imageSrc() {
      if (this.userImage) {
        return `${process.env.VUE_APP_API_BASE_URL}/SFA/public/${this.userImage}`;
      }
      return '';
    },
  },

  methods: {
    formatNumber(value) {
      if (!value) return '0.00';
      const numStr = value.toString().replace(/,/g, '');
      return parseFloat(numStr).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    goBack() {
      this.$router.push('/daily-collections');
    },

    confirmDelete() {
      this.deleteDialog = true;
    },

    deleteItem() {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');
      const id = this.collectionId;

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/collections/daily/delete/${id}`, { userId }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(() => {
        this.deleteDialog = false;
        EventBus.emit('dailyCollectionRecordButtonClick2');
        this.goBack();
      })
      .catch(error => {
        console.error("There was an error deleting the collection!", error);
      });
    },

    fetchCollectionData() {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');
      const id = this.collectionId;

      if (!id) {
        console.error('No collection ID provided');
        return;
      }

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/collections/daily/${id}`, { userId }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      })
      .then(response => {
        console.log("API Response:", response.data);
        if (response.data.collection) {
          const collection = response.data.collection;
          
          this.agentName = collection.agent?.name || 'Mr. Nehan Godage';
          this.userImage = collection.agent?.user_image || null;
          
          if (collection.agent?.mobile_number && collection.agent.mobile_number.length > 0) {
            this.mobileNumber = collection.agent.mobile_number[0].mobile_number;
          } else {
            this.mobileNumber = '+94 77 315 5224';
          }
          
          this.userType = collection.user_type || 'SALES REP';
        }
      })
      .catch(error => {
        console.error("Error fetching collection data:", error);
        this.agentName = 'Mr. Nehan Godage';
        this.mobileNumber = '+94 77 315 5224';
      });
    },
  },
  
  created() {
    this.collectionId = this.$route.params.id;
    this.fetchCollectionData();
  },

  mounted() {
    const dashboardId = 7;
    this.permissions = getPermissions(dashboardId);
  },
};
</script>

<style scoped>
</style>